import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "currentColor≤",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.5 16.5C4.0875 16.5 3.7345 16.3533 3.441 16.0598C3.147 15.7658 3 15.4125 3 15V3C3 2.5875 3.147 2.23425 3.441 1.94025C3.7345 1.64675 4.0875 1.5 4.5 1.5H10.5L15 6V15C15 15.4125 14.8533 15.7658 14.5598 16.0598C14.2658 16.3533 13.9125 16.5 13.5 16.5H4.5ZM9.75 6.75V3H4.5V15H13.5V6.75H9.75Z" }, null, -1)
  ]))]))
}
export default { render: render }